import { Injectable } from '@angular/core';

import { AnalyticsBase } from '@recruitee/analytics';

export enum SidebarHotkeyAction {
  Open = 'open',
  Close = 'close',
}

@Injectable({ providedIn: 'root' })
export class SidebarAnalytics extends AnalyticsBase {
  public readonly namespace = 'Sidebar';
  public readonly requireViewContext = false;

  public trackSidebarHotkeyAction(hotkeyAction: SidebarHotkeyAction): void {
    this.track('SidebarHotkeyAction', { hotkeyAction });
  }
}
